import {
  POWER_BACKUP_POWER_BILLING_FINANCE,
  SUPER_ADMIN,
  powerAdmin1Roles,
  powerAdmin2Roles,
  powerAdmin3Roles,
  powerAdmin4Roles,
} from "common/constant";
import { isAuthorizedUser } from "./isAuthorizedUser";
import { getOptionValue } from "common/enums";

const DEFAULT_STATUS = "Default";

const canApproveAndRevoke = {
  canApprove: true,
  canRevoke: true,
};

export const getStatusForApproval = (
  { approvedBy, revokedBy, status },
  userRoles
) => {
  if (
    status &&
    status !== getOptionValue("billCalculationStatus", DEFAULT_STATUS)
  ) {
    return {
      canApprove: false,
      canRevoke: false,
    };
  }

  if (userRoles.includes(SUPER_ADMIN)) {
    return {
      canApprove: false,
      canRevoke: false,
    };
  }

  if (
    isAuthorizedUser(userRoles, powerAdmin1Roles) &&
    powerAdmin2Roles.includes(approvedBy) &&
    !revokedBy
  ) {
    return canApproveAndRevoke;
  }

  if (
    isAuthorizedUser(userRoles, [...powerAdmin2Roles,POWER_BACKUP_POWER_BILLING_FINANCE]) &&
    ((powerAdmin3Roles.includes(approvedBy) && !revokedBy) ||
      powerAdmin1Roles.includes(revokedBy))
  ) {
    return canApproveAndRevoke;
  }

  if (
    isAuthorizedUser(userRoles, powerAdmin3Roles) &&
    ((powerAdmin4Roles.includes(approvedBy) && !revokedBy) ||
      [...powerAdmin2Roles,POWER_BACKUP_POWER_BILLING_FINANCE].includes(revokedBy))
  ) {
    return { canApprove: true, canRevoke: true };
  }

  if (
    isAuthorizedUser(userRoles, powerAdmin4Roles) &&
    ((!approvedBy && !revokedBy) || powerAdmin3Roles.includes(revokedBy))
  ) {
    return { canApprove: true, canRevoke: false };
  }

  return { canApprove: false, canRevoke: false };
};
